import * as URLS from '@src/constants/URLS.const';
import {
    Squares2X2Icon,
    CpuChipIcon,
    ChartPieIcon,
    IdentificationIcon,
    UserGroupIcon,
} from '@heroicons/react/24/outline';
import { MODULE_KEYS } from '@src/constants/permissions.const';

export const sidebarMenuItems = [
    {
        key: 'dashboard',
        label: 'Dashboard',
        url: URLS.DASHBOARD_URL,
        icon: <Squares2X2Icon className="w-4 h-4" />,
        permissionKey: MODULE_KEYS.Dashboard,
    },
    {
        key: 'sims',
        label: 'SIM Management',
        url: URLS.SIMS_FULL_URL,
        icon: <CpuChipIcon className="w-4 h-4" />,
        permissionKey: MODULE_KEYS.Sims,
    },
    {
        type: 'group',
        key: 'planManagement',
        label: 'Plan Management',
        icon: <ChartPieIcon className="w-4 h-4" />,

        children: [
            {
                key: 'plans',
                label: 'Plans',
                url: URLS.PLANS_FULL_URL,
                permissionKey: MODULE_KEYS['Plan_Management.Plans'],
            },
            {
                key: 'zones',
                label: 'Zones',
                url: URLS.ZONES_FULL_URL,
                permissionKey: MODULE_KEYS['Plan_Management.Zones'],
            },
        ],
    },
    {
        key: 'subAccounts',
        label: 'Sub-Accounts',
        url: URLS.SUB_ACCOUNTS_FULL_URL,
        icon: <IdentificationIcon className="w-4 h-4" />,
        permissionKey: MODULE_KEYS.SubAccounts,
    },
    {
        key: 'userManagements',
        label: 'User Management',
        url: URLS.USER_MANAGEMENT_FULL_URL,
        icon: <UserGroupIcon className="w-4 h-4" />,
        permissionKey: MODULE_KEYS.UserManagement,
    },
    {
        type: 'group',
        key: 'b2cManagement',
        label: 'B2C Management',
        icon: <ChartPieIcon className="w-4 h-4" />,

        children: [
            {
                key: 'b2cUsers',
                label: 'App Users',
                url: URLS.B2C_USERS_FULL_URL,
                permissionKey: MODULE_KEYS['B2CManagement.Users'],
            },
            {
                key: 'b2cPlans',
                label: 'App Plans',
                url: URLS.B2C_PLANS_FULL_URL,
                permissionKey: MODULE_KEYS['B2CManagement.Packages'],
            },
            {
                key: 'b2cDiscountCode',
                label: 'Discount Codes',
                url: URLS.B2C_DISCOUNTCODE_FULL_URL,
                permissionKey: MODULE_KEYS['B2CManagement.Discounts'],
            },
            {
                key: 'b2cSales',
                label: 'Sales',
                url: URLS.B2C_SALES_FULL_URL,
                permissionKey: MODULE_KEYS['B2CManagement.Sales'],
            },
        ],
    },
];
